import React, { useEffect, useState } from 'react'
import CustomerModel from './models/CustomerModel';

function DeleteCustomer(props) {
  const [customerData, setCustomerData] = useState(new CustomerModel() || []);

  useEffect(() => {
    setCustomerData(props.CustomerData);
  }, [props.CustomerData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following customer will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Customer :</b> {customerData.CustomerName}</li>
            <li><b>Mobile : </b>{customerData.MobileNumber}</li>
            <li><b>Email : </b>{customerData.EmailId}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteCustomerDetails" hidden>{JSON.stringify(customerData)}</div>
    </>
  )
}

export default DeleteCustomer